import React, { useEffect } from 'react';
import { useQuery, gql } from '@apollo/client';
import styled from 'styled-components/macro';
import { publicClient } from 'shared/apollo/publicClient';
import { GraphQLFetchPolicies } from 'shared/enums/GraphQLFetchPolicies';
import { env } from 'env';

const HEALTH_CHECK = gql`
  query healthCheck {
    healthCheck {
      success
    }
  }
`;

const HealthCheck = (): JSX.Element | null => {
  const { data } = useQuery(HEALTH_CHECK, {
    client: publicClient,
    context: { headers: { authorization: `Bearer ${env.REACT_APP_PUBLIC_API_KEY}` } },
    fetchPolicy: GraphQLFetchPolicies.NetworkOnly,
  });

  useEffect(() => {
    if (env.NODE_ENV === 'production') {
      const script = document.createElement('script');
      script.src = '//rum-static.pingdom.net/pa-6058a73e7267e1001100005d.js';
      script.async = true;
      document.body.appendChild(script);
    }
  }, []);

  if (!data?.healthCheck?.success) return null;

  return <HealthCheckContainer>True</HealthCheckContainer>;
};

const HealthCheckContainer = styled.div`
  padding: 20px;
  font-size: 40px;
`;

export default HealthCheck;
